export default __webpack_public_path__ + "static/portal/img/map2.5370354.png";